import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { Fancybox as NativeFancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { OptionsType } from '@fancyapps/ui/types/Fancybox/options';

interface Props {
    options?: Partial<OptionsType>;
    delegate?: string;
}

export function Fancybox(props: PropsWithChildren<Props>) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const dialogElement = document.querySelector('.fade.modal');
        if (dialogElement) {
            dialogElement.removeAttribute('tabindex');
        }
    }, [props]);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const delegate = props.delegate || '[data-fancybox]';
        const options = {
            Carousel: { infinite: false },
            ...props.options,
        };

        NativeFancybox.bind(container, delegate, options);

        return () => {
            NativeFancybox.unbind(container);
            NativeFancybox.close();
        };
    }, []);

    return <div ref={containerRef}>{props.children}</div>;
}
